export class Document {
    uid: string;
    description: string;
    companyUID: string;
    status: DocumentStatus;
    sentUserUID: string;
    approvingUserUID: string;
    expirationDate: number;
    expirationDateString: string;
    category: string;
    fileURL: string;

    pending: boolean;

    reason: string;
}

export enum DocumentStatus {
    DISAPPROVED = -1,
    EXPIRED,
    WAITING_APPROVAL,
    APPROVED,
    OK,
}

export class DocumentCategory {
    uid: string;
    description: string;
}



// WEBPACK FOOTER //
// ./src/app/model/document.ts